import { Injectable } from '@angular/core';
import { Project } from '../models/project';
import { PObject } from '../models/object';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { WidgetMapRegion } from '../models/widget';
import { map } from 'rxjs/operators';

@Injectable()
export class ObjectService {

  constructor(private  http: HttpClient) {
  }

  get(project?: Project): Observable<PObject[]> {
    return this.http.get<any>(`${project.url}/objects`)
      .pipe(map(json => {
        return json.data.map(row => {
          return new PObject(row);
        });
      }));
  }

  deleteMany(project: Project, ids: number[]): Observable<void> {
    const data = JSON.stringify({ ids: ids });
    return this.http.post<any>(`${project.url}/destroy-objects`, data)
      .pipe(map(json => {
        return;
      }))
  }

  update(object: PObject): Observable<PObject> {
    let data = object.toJson();

    return this.http.put<any>(`${object.url}`, data)
      .pipe(map(json => {
        return new PObject(json);
      }));
  }

  create(object: PObject, project: Project): Observable<PObject> {
    let data = object.toJson();

    return this.http.post<any>(`${project.url}/objects`, data)
      .pipe(map(json => {
        return new PObject(json);
      }));
  }

  destroy(object: PObject): Observable<void> {
    return this.http.delete<any>(`${object.url}`)
      .pipe(map(json => {
      }));
  }

  getRegions(object: PObject): Observable<WidgetMapRegion[]> {
    return this.http.get<any>(`${object.url}/regions`)
      .pipe(map(json => {
        return json.data.map(row => {
          return new WidgetMapRegion(row);
        });
      }));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/object.service.ts